import { ArrowChevronRight } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';
import Image from 'next/legacy/image';
import type { ReactNode } from 'react';

import type { Course } from '@/types';

import { _99CLUB_DISCORD_URL, _99CLUB_STUDY_GUIDE_URL } from '../99club';

export type MyPageGnbItem = {
  name: string;
  url: string;
  icon: ReactNode;
  isNewTab?: boolean;
};

export const MY_PAGES: Array<{ name: string; href: string }> = [
  {
    name: '나의 수강',
    href: '/users/my-page?tab=나의 수강',
  },
  {
    name: '결제 내역',
    href: '/users/my-page?tab=결제 내역',
  },
  {
    name: '계정 정보',
    href: '/users/my-page?tab=계정 정보',
  },
];

export const MY_PAGE_GNB_BUTTONS: Partial<Record<Course, MyPageGnbItem[]>> = {
  '백엔드 커리어 코칭': [
    {
      name: '코칭 예약',
      url: '/coaching/reservation',
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '프론트엔드 커리어 코칭': [
    {
      name: '코칭 예약',
      url: '/coaching/reservation',
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '플러스 백엔드 코스': [
    {
      name: '출석 체크',
      url: `/plus/attendance/be`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '학습 랭킹',
      url: `/plus/leaderboard/be`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '평가 현황',
      url: `/plus/evaluation/be`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '멘토링 예약',
      url: `/plus/mentoring/be`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '과제 제출',
      url: `/plus/assignments/be`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '교육 평가',
      url: `/plus/survey/be`,
      isNewTab: true,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '플러스 프론트엔드 코스': [
    {
      name: '출석 체크',
      url: `/plus/attendance/fe`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '학습 랭킹',
      url: `/plus/leaderboard/fe`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '평가 현황',
      url: `/plus/evaluation/fe`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '멘토링 예약',
      url: `/plus/mentoring/fe`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '과제 제출',
      url: `/plus/assignments/fe`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '교육 평가',
      url: `/plus/survey/fe`,
      isNewTab: true,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '플러스 AI 코스': [
    {
      name: '출석 체크',
      url: `/plus/attendance/ai`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '학습 랭킹',
      url: `/plus/leaderboard/ai`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '평가 현황',
      url: `/plus/evaluation/ai`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '멘토링 예약',
      url: `/plus/mentoring/ai`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '과제 제출',
      url: `/plus/assignments/ai`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '교육 평가',
      url: `/plus/survey/ai`,
      isNewTab: true,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '취업 리부트 코스': [
    {
      name: '출석 체크',
      url: `/attendance`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '학습 랭킹',
      url: `/leaderboard`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
  '99클럽 코딩테스트 스터디': [
    {
      name: '99클럽 홈',
      url: `/99club/lms`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '레벨 미션',
      url: `/99club/levels`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '문제 모아보기',
      url: `/99club/problems`,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '디스코드',
      url: _99CLUB_DISCORD_URL,
      isNewTab: true,
      icon: (
        <Image
          src='/images/icons/link-icon-light-gray.svg'
          width={16}
          height={16}
          alt='signin-icon'
        />
      ),
    },
    {
      name: '스터디 가이드',
      url: _99CLUB_STUDY_GUIDE_URL,
      isNewTab: true,
      icon: (
        <Image
          src='/images/icons/link-icon-light-gray.svg'
          width={16}
          height={16}
          alt='signin-icon'
        />
      ),
    },
  ],
  이노베이션캠프: [
    {
      name: '출석 체크',
      url: '/attendance',
      isNewTab: false,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '학습 랭킹',
      url: '/leaderboard',
      isNewTab: false,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
    {
      name: '과제 제출',
      url: '/assignments',
      isNewTab: false,
      icon: <ArrowChevronRight size={16} color={`${vars.neutral[50]}`} />,
    },
  ],
};
